import { createContext, useContext, useState, useCallback, useMemo } from "react";
import es from "./es";
import en from "./en";

const translations = { es, en };

const LanguageContext = createContext({
  lang: "es",
  setLang: () => {},
  t: es,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem("at-lang") || "es";
  });

  const setLang = useCallback((newLang) => {
    localStorage.setItem("at-lang", newLang);
    setLangState(newLang);
  }, []);

  const t = useMemo(() => translations[lang] || es, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}

// Default export for backward compatibility — static Spanish
// Components should migrate to useTranslation() hook
const t = es;
export default t;
